export function AddressParameter(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

var lang = function inserted(el, binding, vnode) {
  const ar = AddressParameter("language")
  if (ar == "ar") {
    el.className = el.className + ' artest'
  }
};
const install = function (Vue) {
  Vue.directive("lang", lang);
};

if (window.Vue) {
  // window["lang"] = lang;
  Vue.use(install); // eslint-disable-line
}

lang.install = install;
export default lang;
